import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import Flex from "../../../../../components/Flex";
import PageLayout from "../../../../../components/PageLayout";
import CustomTabs from "../../../../../components/app/CustomTabs";
import { useReduceDisclosure } from "../../../../../hooks/use-reduce-disclosure";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  getXtenantId,
  roleFilter,
} from "../../../../../utils/utils";
import {
  Box,
  // IconButton,
  // InputAdornment,
  // TextField,
} from "@mui/material";
import Text from "../../../../../components/Text";
import { useDebounce } from "../../../../../hooks/use-debounce";
// import { ClearIcon } from "@mui/x-date-pickers/icons";
import UpsertFlag from "./UpsertFlag";
import UpsertPatientFlag from "../../patient/flags/UpsertPatientFlag";
import AsyncFilterSelect from "../../../../../components/AsyncFilterSelect";
import { useGetFlagList } from "../../../../../queries/flags/flags/use-get-flag-list";
import SearchInput from "../../../../../components/SearchInput";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import { CHART_TYPOGRAPHY } from "../../../../../components/app/provider/patient/chart";

const CommunicationLayout = () => {
  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab == "flag-settings" ? "" : (currentTab as string);
  });
  const navigate = useNavigate();

  const [upsertPatientFlagDisclosure, upsertFlagDisclosure] =
    useReduceDisclosure(2);

  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const { data: flagDropdownList, isLoading: flagDropdownListLoading } =
    useGetFlagList({
      enabled: activeTab === "patient-flag-settings",
      pagination: DEF_PAGINATION,
      xTENANTID: getXtenantId(),
      gridSorting: [],
      active: true,
      archive: false,
    });
  const [selectedFlag, setSelectedFlag] = useState<any>();
  const [flagSearch, setFlagSearch, instantFlagSearch] =
    useDebounce<string>("");

  // Function to render the appropriate filter component based on active tab
  const renderFilters = () => {
    switch (activeTab) {
      case "":
        return (
          <Flex width={"100%"} justifyContent={"flex-end"}>
            <Box>
              {/* <TextField
                placeholder="Search Flag"
                fullWidth
                variant="outlined"
                size="small"
                sx={{ fontSize: "14px" }}
                value={instantFlagSearch}
                onChange={(e) => {
                  setFlagSearch(e.target.value);
                }}
                InputProps={{
                  sx: {
                    "& .MuiInputBase-input": { fontSize: "14px" },
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setFlagSearch("");
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> */}
              <SearchInput
                placeholder="Search by Flag Name"
                searchKey={instantFlagSearch}
                onSearch={setFlagSearch}
              />
            </Box>
            <Box mx={2}>
              {/* <Button
                variant="contained"
                onClick={() => {
                  upsertFlagDisclosure.open();
                }}
                startIcon={<AddIcon />}
              >
                Add New Flag
              </Button> */}
              <StyledButtonV2
                label="Assign Flag to Patient"
                onClick={() => {
                  upsertFlagDisclosure.open();
                }}
                startIcon={<AddIcon />}
              />
            </Box>
            <UpsertFlag disclosureHost={upsertFlagDisclosure} />
          </Flex>
        );
      case "patient-flag-settings":
        return (
          <Flex width={"100%"} justifyContent={"flex-end"}>
            <Box width={"200px"}>
              <AsyncFilterSelect
                required
                loading={flagDropdownListLoading}
                placeholder="Select Flag"
                enableFilterOption
                renderCustomLabel={(option) => (
                  <Flex alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: "30px",
                        backgroundColor: option.color,
                        borderRadius: "2px",
                        flexShrink: 0,
                      }}
                    />
                    <Text fontSize={CHART_TYPOGRAPHY.body5.fontSize}>
                      {option.label}
                    </Text>
                  </Flex>
                )}
                renderSelectedValue={(option) => (
                  <Flex alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: "30px",
                        height: "20px",
                        backgroundColor: option.color,
                        borderRadius: "2px",
                        flexShrink: 0,
                      }}
                    />
                  </Flex>
                )}
                options={flagDropdownList?.data?.content?.map((it) => ({
                  value: it?.uuid,
                  label: it?.name,
                  color: it?.color,
                }))}
                value={selectedFlag}
                onChange={(val) => setSelectedFlag(val)}
              />
            </Box>
            <Box mx={2}>
              <StyledButtonV2
                label="Add Patient Flag"
                variant="primary"
                onClick={() => {
                  upsertPatientFlagDisclosure.open();
                }}
                shouldAddIcon
              />
            </Box>
            {upsertPatientFlagDisclosure.opened && (
              <UpsertPatientFlag disclosureHost={upsertPatientFlagDisclosure} />
            )}
          </Flex>
        );
      default:
        return <></>;
    }
  };

  return (
    <PageLayout
      header={
        /* Tabs and Filter Bar Combined */
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
            paddingBottom: "5px",
            marginBottom: "15px",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <CustomTabs
            tabsData={roleFilter({
              list: TABS_DATA,
              compWith: {
                flagSetting: true,
                patientFlagSetting: true,
              },
            })}
            value={activeTab}
            onChange={(v) => {
              setFlagSearch("");
              setActiveTab(v);
              navigate(v);
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            {renderFilters()}
          </div>
        </div>
      }
    >
      <Outlet
        context={{
          pagination,
          setPagination,

          selectedFlag,
          setSelectedFlag,
          flagSearch,
        }}
      />
    </PageLayout>
  );
};

export default CommunicationLayout;

const TABS_DATA = [
  {
    value: "",
    label: "Flag Settings",
  },
  {
    value: "patient-flag-settings",
    label: "Patient Flag Settings",
  },
];
